export const GET_KPIS = `
query get_kpis($module: moduleName!) {
    get_kpis(module: $module)  {
        success
        errorText
        data {
            name
            category
            time_frame
            icon
            graph_type
            event_size
        } 
    }
}
`;
